<template>
  <div class="flex flex-wrap pl-2 item-detail__actions">
    <div class="h-6 w-64 rounded-full bg-secondary-500 dark:bg-gray-700" />
  </div>
  <span class="sr-only">{{ $t("main.loaderCardGridSkeleton.loading") }}</span>
</template>
